import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CocheSeguro } from '../modelos/cocheSeguro.model';
import { StorageService } from '../services/storage.service';
import { Configuration } from '../Constants/configuration';
import { RequestServices } from '../services/request.service';
import { FomatDateClass } from '../tools/date/formatDate';

@Component({
    selector: 'login-auth',
    templateUrl: './login-auth.component.html'
})

export class LoginAuthComponent implements OnInit {
    public const: Configuration = new Configuration();
    private cocheSeguro: CocheSeguro = new CocheSeguro();
    public status: string = ""
    private months: string[] = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    constructor(private router: Router, private storageService: StorageService, private routers: ActivatedRoute, private requestService: RequestServices) { }

    ngOnInit(): void {
        this.status = "Validating parameters . . .";
        this.routers.queryParams.subscribe(params => {
            console.log("params: ", params)
            if (params) {
                if (params.token) {
                    let data = { 't': params.token };
                    this.status = 'Validating credentials . . . ';
                    this.requestService.postRequest({ projectName: this.const.URLQUATTROAUTH, apiName: 'validate-token-v2', dataJSON: data }).subscribe(
                        response => {
                            if (response.error) {
                                if (this.const.PLATFORM) {
                                    window.location.href = this.const.URLPLATFORM + 'inicio';
                                } else {
                                    this.router.navigate(['/inicio']);
                                }
                            } else {
                                if (response.is_valid) {
                                    if (params.m) {
                                        if (this.storageService.ifExist("cocheSeguro")) {
                                            this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
                                            this.cocheSeguro.m = params.m;
                                            this.cocheSeguro.tkn = params.token;
                                            this.cocheSeguro.clEnt = params.c;
                                            this.storageService.setItem("cocheSeguro", JSON.stringify(this.cocheSeguro));
                                            let source = (!!params?.source) ? params?.source : 'email';
                                            let date = (!!params?.date) ? params?.date.split("-") : FomatDateClass.getFormatDate(new Date(), 'yyyy-MM-dd').split("-");

                                            let [year, month, day] = date;
                                            let campaign = `renovaciones.${this.months[(+month) - 1]}.${year.slice(2, 4)}`;
                                            switch (params.r) {
                                                case 'renovaciones':
                                                    this.router.navigate(['mi-cuenta/renovaciones'],
                                                        { queryParams: { "utm_source": source, "utm_medium": "renovaciones", "utm_campaign": campaign } });
                                                    break;
                                                case 'pago-en-linea':
                                                    this.storageService.setItem('polizaID', params.p);
                                                    this.router.navigate(['mi-cuenta/pago'],
                                                        { queryParams: { "utm_source": source, "utm_medium": "renovaciones", "utm_campaign": campaign } });
                                                    break;
                                                case 'pdf-poliza':
                                                    if(params?.p){
                                                        this.storageService.setItem('policyID', params.p);
                                                        this.router.navigate(['/archivos']);
                                                    }                                                    
                                                    break;
                                                default:
                                                    if (this.const.PLATFORM) {
                                                        window.location.href = this.const.URLPLATFORM + 'mi-cuenta/' + params.r;
                                                    } else {
                                                        this.router.navigate(['mi-cuenta/' + params.r]);
                                                    }
                                                    break;
                                            }
                                        }
                                    } else {
                                        if (this.const.PLATFORM) {
                                            window.location.href = this.const.URLPLATFORM + 'inicio';
                                        } else {
                                            this.router.navigate(['/inicio']);
                                        }
                                    }
                                } else {
                                    if (response.message == 'x/tIrUjF6zBkNIG5vpmWaoQvzB/bBLFvThNYbZ9z1GY=') {
                                        sessionStorage.action = 'login';
                                        if (this.const.PLATFORM) {
                                            window.location.href = this.const.URLPLATFORM + 'inicio';
                                        } else {
                                            this.router.navigate(['/inicio']);
                                        }
                                    } else {
                                        if (this.const.PLATFORM) {
                                            window.location.href = this.const.URLPLATFORM + 'inicio';
                                        } else {
                                            this.router.navigate(['/inicio']);
                                        }
                                    }
                                }
                            }
                        },
                        error => {
                            console.error('error', error);
                            if (this.const.PLATFORM) {
                                window.location.href = this.const.URLPLATFORM + 'inicio';
                            } else {
                                this.router.navigate(['/inicio']);
                            }
                        }
                    );
                } else {
                    if (this.const.PLATFORM) {
                        window.location.href = this.const.URLPLATFORM + 'inicio';
                    } else {
                        this.router.navigate(['/inicio']);
                    }
                }
            } else {
                if (this.const.PLATFORM) {
                    window.location.href = this.const.URLPLATFORM + 'inicio';
                } else {
                    this.router.navigate(['/inicio']);
                }
            }
        });
    }

}